import ProjectHighlights from './project-highlights';

export default ProjectHighlights;
